import React from "react";

const While_Real_Life_Example = () => {
  return (
    <div>
      <h1>While_Real_Life_Example Component</h1>
      <p>Content for While_Real_Life_Example goes here...</p>
    </div>
  );
};

export default While_Real_Life_Example;
